<template>
  <SimpleModuleDashboard
    :module-id="Modules.INFORME_VISITAS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="dashboardActions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({ Modules, Profiles }),
  computed: {
    isSeller() {
      return !!Helper.getSeller()
    },
    dashboardActions() {
      return this.isSeller
        ? [
          { id: 'crudReportSeller', reference: 'crudReportSeller', route: 'ReportsVisitsStaffCrudReportSeller', tone: 'primary' },
          { id: 'queryAnalysisSeller', reference: 'queryAnalysisSeller', route: 'ReportsVisitsStaffQueryAnalysisSeller', tone: 'secondary' },
        ]
        : [
          { id: 'crudReport', reference: 'crudReport', route: 'ReportsVisitsStaffCrudReport', tone: 'primary' },
          { id: 'queryAnalysis', reference: 'queryAnalysis', route: 'ReportsVisitsStaffQueryAnalysis', tone: 'secondary' },
        ]
    },
  },
}
</script>
